// Per-page-load cache for /api/diStaffNames — the small, any-signed-in-user roster
// (email + name) behind useNameFor. First caller fetches, the rest share the promise.

let inflight = null;

export function loadStaffNames() {
  if (inflight) return inflight;
  inflight = fetch('/api/diStaffNames', { credentials: 'include' })
    .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
    .then(data => data.users || [])
    .catch(err => { inflight = null; throw err; });
  return inflight;
}
